import React, { useEffect, useState } from "react";
import {
  ButtonAlternativeStyled,
  ButtonPrimaryStyled,
} from "src/components/custom/buttons/buttons.styled";
import { LargeHeadingStyled } from "src/components/custom/texts/texts.styled";
import {
  DownloadContainerStyled,
  FlexPDFButtonsStyled,
  SpinnerContainerStyled,
} from "src/pages/student-pages/cart/cart.styled";
import { Card, Spin, Skeleton } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import { useGetBillPdfMutation } from "src/services/cartServices";
import { useNavigate, useParams } from "react-router-dom";
import { getPayPdfPage } from "src/Api/content";
import { useLocale } from "src/i18n/localeContext";
import { StrapiError } from "src/pages/StrapiError";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

function PaymentReceipt() {
  const [getInvoiceFile, { data: dataPdf, isLoading: isLoadingFile }] = useGetBillPdfMutation();
  const { invoiceId, peopleId } = useParams();
  const navigate = useNavigate();
  const [PDFPages, setPDFPages] = React.useState<number>(0);
  const { locale } = useLocale();
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const [payPdfPage, setPayPdfPage] = useState<any>(null);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setPayPdfPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    getPayPdfPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setPayPdfPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setPayPdfPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  React.useEffect(() => {
    getInvoiceFile({ id: invoiceId, people: peopleId, locale });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceId, peopleId, locale]);

  const onDocLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPDFPages(numPages);
  };

  const getPdfPages = () => {
    const pages: JSX.Element[] = [];
    for (let index = 1; index <= PDFPages; index++) {
      pages.push(
        <Page
          pageNumber={index}
          width={window.innerWidth / 1.4}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          renderMode="canvas"
        />,
      );
    }
    return pages;
  };

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setPayPdfPage(null);
      }}
    />;
  }

  return (
    <DownloadContainerStyled>
      <FlexPDFButtonsStyled>
        <ButtonPrimaryStyled
          type="link"
          href={`data:application/pdf;base64,${dataPdf}`}
          download={
            isLoadingContent
              ? "Recibo de pago.pdf"
              : payPdfPage?.download_filename || "Recibo de pago.pdf"
          }
        >
          {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 120 }} /> : (payPdfPage?.download_button || "Descargar PDF")}
        </ButtonPrimaryStyled>
        <ButtonAlternativeStyled onClick={() => navigate(-1)}>
          {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (payPdfPage?.back_button || "Volver atrás")}
        </ButtonAlternativeStyled>
      </FlexPDFButtonsStyled>
      <Card>
        <LargeHeadingStyled>
          {isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 300 }} /> : (payPdfPage?.title || "Pago efectuado recientemente:")}
        </LargeHeadingStyled>
        {isLoadingFile && (
          <SpinnerContainerStyled>
            <Spin spinning={isLoadingFile} size="large" />
          </SpinnerContainerStyled>
        )}
        <Document file={`data:application/pdf;base64,${dataPdf}`} onLoadSuccess={onDocLoadSuccess}>
          {getPdfPages()}
        </Document>
      </Card>
    </DownloadContainerStyled>
  );
}

export default PaymentReceipt;
